var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useStyles } from "./AudioStyles";
import ButtonBase from '@material-ui/core/ButtonBase';
import { formatSeconds } from "../../../../helpers/dateManagement";
import { useMedia } from "../../../../hooks/useMedia";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';

var _ref2 = /*#__PURE__*/_jsx(PlayArrowIcon, {});

var _ref3 = /*#__PURE__*/_jsx(PauseIcon, {});

export const Audio = _ref => {
  let content = _ref.content;
  const classes = useStyles();
  const audioRef = useRef();

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        duration = _useState2[0],
        setDuration = _useState2[1];

  const _useMedia = useMedia(audioRef),
        paused = _useMedia.paused,
        progress = _useMedia.progress,
        handlePlayClick = _useMedia.handlePlayClick,
        handleChangeProgress = _useMedia.handleChangeProgress;

  return React.createElement(React.Fragment, null, React.createElement("audio", {
    onDurationChange: event => setDuration(event.target.duration),
    ref: audioRef,
    className: classes.audio,
    control: true
  }, _jsx("source", {
    type: "audio/mp3",
    src: content
  })), _jsx("div", {
    className: classes.container
  }, void 0, _jsx(ButtonBase, {
    disableRipple: true,
    onClick: handlePlayClick,
    className: classes.icon
  }, void 0, paused ? _ref2 : _ref3), _jsx("div", {
    onMouseUp: handleChangeProgress,
    className: classes.progress
  }, void 0, _jsx("div", {
    style: {
      width: "".concat(progress, "%")
    }
  })), duration && duration !== Infinity && _jsx("span", {
    className: classes.duration
  }, void 0, formatSeconds(audioRef.current.currentTime || duration))));
};